import { DisputeStatus } from "enums";
import { useUserInfo } from "state";
import { DisputeDetail, DisputeSummary } from "types";

export default function useShowAsEscalated( dispute: DisputeSummary | DisputeDetail ): boolean {
    const { isInternalUser } = useUserInfo();

    const isEscalated = dispute?.isEscalated ? dispute?.isEscalated : false;
    const isCompleted = dispute.disputeStatusId === DisputeStatus.Closed;

    return (
        isInternalUser === true
        && isCompleted === false
        && isEscalated === true
    );
}